import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Checkbox, Icon, IconButton } from '@mui/material';
import ColorBox from '@/components/common/ColorBox';
import Style from '@/types/Style.type';

type Props = {
  onEdit: (id: number) => void;
  onDelete: (id: number, number: string) => void;
  rows: Array<Style>;
};

const StyleTableBody: React.FC<Props> = ({ onEdit, onDelete, rows }) => {
  return (
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.id}>
          <TableCell>{row.name}</TableCell>
          <TableCell>
            <Icon sx={{color: row.color}}>{row.icon}</Icon>
          </TableCell>
          {/*<TableCell>
            <ColorBox backgroundColor={row.color} width={25} height={25} />
          </TableCell>*/}
          <TableCell>
            <Checkbox disabled checked={row.nextDateFlag} />
          </TableCell>
          <TableCell>
            <IconButton onClick={() => onEdit(row.id)}>
              <EditIcon />
            </IconButton>
            <IconButton disabled={row.undeletable} onClick={() => onDelete(row.id, row.name)}>
              <DeleteIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};
export default StyleTableBody;
